/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bar_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One numeric column draws a simple bar chart, one bar per category.`)
};

const es_bar_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una columna numérica dibuja un gráfico de barras simple, una barra por categoría.`)
};

const de_bar_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine numerische Spalte zeichnet ein einfaches Balkendiagramm, einen Balken pro Kategorie.`)
};

const nl_bar_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eén numerieke kolom tekent een eenvoudig staafdiagram, één staaf per categorie.`)
};

const fr_bar_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une colonne numérique dessine un graphique à barres simple, une barre par catégorie.`)
};

const it_bar_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una colonna numerica disegna un semplice grafico a barre, una barra per categoria.`)
};

const pt_br2_bar_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma coluna numérica desenha um gráfico de barras simples, uma barra por categoria.`)
};

const pt_bar_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma coluna numérica desenha um gráfico de barras simples, uma barra por categoria.`)
};

const ja_bar_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数値列が1つだけの場合、カテゴリごとに1本の単純な棒グラフが描画されます。`)
};

const zh_bar_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一列数值绘制出简单柱状图，每个类别一根柱子。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bar_ex1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bar_ex1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bar_ex1", locale)
	if (locale === "en") return en_bar_ex1(inputs)
	if (locale === "es") return es_bar_ex1(inputs)
	if (locale === "de") return de_bar_ex1(inputs)
	if (locale === "nl") return nl_bar_ex1(inputs)
	if (locale === "fr") return fr_bar_ex1(inputs)
	if (locale === "it") return it_bar_ex1(inputs)
	if (locale === "pt-BR") return pt_br2_bar_ex1(inputs)
	if (locale === "pt") return pt_bar_ex1(inputs)
	if (locale === "ja") return ja_bar_ex1(inputs)
	return zh_bar_ex1(inputs)
};